import React, {useState, useContext} from "react";

import {BackHandler}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import { useFocusEffect } from '@react-navigation/native';

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import FormularioBuscarPedido, {TIPO_GESTAO_PEDIDO} from '../componentes/FormularioBuscarPedido'

import {TELA_MEUS_PEDIDOS} from '../util/constantes'

import {email_verificado as wsEmail_verificado} from '../ws/ws_usuarios'

import contexto from '../util/contexto'

import * as util from '../util/util'



export default function TelaMeusPedidos(){
	
	const {valorContexto} = useContext(contexto);

	const navegacao = new useNavigation();

	const [podeCriar, setPodeCriar] = useState(0)


	const voltar = () => {
	
		navegacao.replace(util.processaVoltar())
		return true;
	};


	useFocusEffect(React.useCallback(() => {
		
		console.log('TelaMeusPedidos');
		
		BackHandler.addEventListener('hardwareBackPress', voltar);
		
		preparacaoIncial();
		
		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};
		
	}, []));


	

	const preparacaoIncial= async ()=>{
	
		let retorno = await wsEmail_verificado(valorContexto.idUsuarioAtual);
			
		setPodeCriar(retorno!=null && retorno.verificado>0?1:-1)
		
		let atualizarMsg = false;
	}


	return (

		<ViewDegradeVertical titulo="Meus Pedidos" voltar={()=>voltar()}>  
			<FormularioBuscarPedido tipo={TIPO_GESTAO_PEDIDO} podeCriar={podeCriar} voltarPara={TELA_MEUS_PEDIDOS}/>
		</ViewDegradeVertical>
	);
}